const API_BASE_URL = resolveApiBaseUrl();

function buildUrl(path, query = {}) {
  const normalizedPath = normalizePath(path);
  const base = API_BASE_URL || getDefaultBaseUrl();
  const url = buildMergedUrl(base, normalizedPath);

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });

  return url.toString();
}

export async function apiRequest(path, options = {}) {
  const { query, body, headers, ...rest } = options;
  const response = await fetch(buildUrl(path, query), {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...headers,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
    ...rest,
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload?.message || 'Request failed.');
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

function resolveApiBaseUrl() {
  const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/$/, '');

  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  return '';
}

function getDefaultBaseUrl() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return '';
}

function normalizePath(path) {
  return String(path || '').replace(/^\/+/, '');
}

function buildMergedUrl(base, path) {
  const url = new URL(base || '', getDefaultBaseUrl() || 'http://localhost');
  const baseSegments = splitPathname(url.pathname);
  const pathSegments = splitPathname(path);

  if (
    baseSegments.length > 0 &&
    pathSegments.length > 0 &&
    baseSegments[baseSegments.length - 1] === pathSegments[0]
  ) {
    pathSegments.shift();
  }

  url.pathname = `/${[...baseSegments, ...pathSegments].join('/')}`;

  return url;
}

function splitPathname(pathname) {
  return String(pathname || '')
    .split('/')
    .filter(Boolean);
}
